<template>
    <div>
        <b-tab no-body :title="$tc('message.allergies',1)" id="tab2" :active="pathHas($tc('message.allergies',1))"> 
            <b-link class="ml-4" variant="primary" @click="toAllergie" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
            </b-link>
            <b-card-body>
                <div v-if="!mobileView">
                    <vue-good-table id="allergie" v-if="notEmpty(allergiesRows)" :columns="allergiesColumns" :rows="allergiesRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onAllergieRowClick" />
                </div>
                <div v-else>
                    <div>
                        <div class="ltemp--content--box border border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded bg-white" v-for="(row, x) in allergiesRows" :key="x"  @click="onAllergieRowClickMobile(row.slug)"> <!-- v-for="(row, x) in medecinesRows" :key="x"  @click="onMedecineRowClickMobile(row.slug)" -->
                            <div class="trajet__info bg-white mt-2 px-2" > <!-- v-for="(item, index) in ligne_temps" :key="index" -->
                                <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                    <span class="d-flex align-items-center text-gray">
                                        <!-- <i class="fa fa-calendar" aria-hidden="true"></i> -->
                                        <span class="px-1 mr-2"> {{ row.description }} </span>
                                    </span>
                                    <span class="">
                                        <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary"><!-- @click="onMedecineRowClickMobile(row.slug) " -->
                                            <span class="d-none d-md-block">Voir</span>
                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                        </b-button> 
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <div>
            </div>
        </b-tab>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
export default {
    name: "Allergie",
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        mAllergies: function () {
            return (typeof this.mMedicalFile.allergies == "object" ? this.mMedicalFile.allergies : []);
        },
        allergiesRows: function () {
            let aArray = [];

            _.forEach(this.mAllergies, function (allergy) {
                aArray.push({
                    description: allergy.description,
                    date: allergy.date,
                    slug: allergy.slug
                })
            })

            return aArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            mobileView: true,
            allergiesColumns: [{
                    label: 'Description',
                    field: 'description',
                }
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },  
        toAllergie() {
            this.$router.push({
                name: 'add-allergy',
                params: {
                    file: this.file_id
                }
            })
        },
        onAllergieRowClick(params) {
            this.$router.push({
                name: 'allergy',
                params: {
                    allergy: params.row.slug
                }
            });
        },
        onAllergieRowClickMobile(params) {
            // console.log(params)
            this.$router.push({
                name: 'allergy',
                params: {
                    allergy: params
                }
            });
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        
    }
}
</script>
<style lang="">
    
</style>